import React from "react";
import styles from "./Legend.module.scss";

interface LegendItem {
  name: string;
  color: string;
}

interface CustomLegendProps {
  items: LegendItem[];
  itemsPerRow?: number; // for desktop; responsive handled in CSS
}

/**
 * CustomLegend component renders a custom legend for the bar chart,
 * displaying labeled colored dots for different user types.
 *
 * @component
 */
const CustomLegend: React.FC<CustomLegendProps> = ({
  items,
  itemsPerRow = 4, // default to 4 items per row on desktop
}) => {
  return (
    <div
      className={styles.legendContainer}
      style={{
        gridTemplateColumns: `repeat(${itemsPerRow}, minmax(0, 1fr))`,
      }}
    >
      {items.map((item, idx) => (
        <div key={idx} className={styles.legendItem}>
          <div
            className={styles.legendDot}
            style={{ backgroundColor: item.color }}
          />
          {item.name}
        </div>
      ))}
    </div>
  );
};

export default CustomLegend;
